import React, { useState } from "react";
import Header from "../../Components/Header";
import SellerHeader from "../../Components/SellerHeader";
import SellerSidebar from "../../Components/SellerSidebar";
import { WithContext as ReactTags } from "react-tag-input";

import Select from "react-select";
import {
  sketch,
  svg1,
  svg2,
  svg3,
  svg4,
  svg5,
  upperarrow,
} from "../../Constant/Index";
import Footer from "../../Components/Footer";
import AccessControl from "../../Components/Auth/AccessControl";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ReUse from "../../services/helpers/reUse";
import AppService from "../../services/appServices";
import { toast } from "react-toastify";
import {
  clearResponseMessageAfterDelay,
  errorMessage,
  successMessage,
} from "../../redux/slices/responseMessage.slice";
import { SellerAddProduct } from "../../Hooks/productInventory/SellerAddProduct";
import VariantMeta from "./VariantMeta";
import { useEffect } from "react";
import SelectedAttributeValues from "./SelectedAttributeValues";
import RenderUploadedImage from "./RenderUploadedImage";
import BulkVariant from "./BulkVariant";
import IndividualVariant from "./IndividualVariant";
import CustomButton from "../../Components/ReUse/Components/Button";
import ResponseMessage from "../../Components/ReUse/ResponseMessage";
import FieldError from "../../Components/ReUse/FieldError";
import RenderImage from "../../Components/ReUse/RenderImage";
import { SketchPicker, TwitterPicker } from "react-color";

const KeyCodes = {
  comma: 188,
  enter: 13,
};

const delimiters = [KeyCodes.comma, KeyCodes.enter];

function Addingproduct() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState();
  const [truefile, setTruefile] = useState();
  const [fileupload, setFileupload] = useState();
  const [addModalIsOpen, setAddModalIsOpen] = useState(false);
  const [statusMessage, setStatusMessage] = useState("");
  const [attributeOptions, setAttributeOptions] = useState([]);
  const [attributes, setAttributes] = useState([]);
  const [attributesLoader, setAttributesLoader] = useState(false);
  const [multiImageFiles, setMultiImageFiles] = useState([]);
  const [uploadImages, setUploadImages] = useState([]);

  const [productCategories, setProductCategories] = useState([]);
  const [productSubCategories, setProductSubCategories] = useState([]);
  const [selectedProductCategory, setSelectedProductCategory] = useState(null);
  const [selectedProductSubCategory, setSelectedProductSubCategory] =
    useState(null);
  const [categoriesLoader, setCategoriesLoader] = useState(false);
  const [subCategoriesLoader, setSubCategoriesLoader] = useState(false);
  const [picker, setPicker] = useState(false);

  const [choiceAttributes, setchoiceAttributes] = useState([]);
  const [choice, setChoice] = useState([]);
  const [choiceOptions, setChoiceOptions] = useState([]);
  const [choiceNo, setChoiceNo] = useState([]);
  const [colors, setColors] = useState([]);
  const [colorssdsd, setColorssdsdsd] = useState([]);
  const [storevalue, setStoreValue] = useState([]);
  const [storval, setStoreVal] = useState([]);
  // minimoq, maximoq, price, variantTitle
  const [minimoq, setMinimoq] = useState("");
  const [maximoq, setMaximoq] = useState("");
  const [price, setPrice] = useState("");
  const [meta,setMeta] = useState([]);


  const extractAttributeValues = () => {
    try {
      if (!selectedAttributeValues || !Array.isArray(selectedAttributeValues)) {
        return [];
      }

      const attributeValues = selectedAttributeValues.map(
        ({ selectedAttribute, values }) => {
          if (!selectedAttribute || !values || !Array.isArray(values)) {
            return [];
          }

          const labels = values?.map(({ text }) => text);
          return { [selectedAttribute]: labels };
        }
      );

      // console.log(selectedAttributeValues, "my-labels-all-time");

      const mergedAttributes = Object.assign({}, ...attributeValues);
      console.log(mergedAttributes, "merge");
      return mergedAttributes;
    } catch (error) {
      return [];
    }
  };

  useEffect(() => {
    setColorssdsdsd(
      colors?.map((item) => ({
        label: item?.name,
        value: item?.code,
      }))
    );
  }, [colors]);

  const [selectedColors, setSelectedColors] = useState([]);
  // console.log(selectedColors, "selected-color");
  let [allCode, setAllCode] = useState([]);

  console.log(allCode, "do thedue");

  let valFunc = selectedColors?.map((item) => item?.value);
  let CheckValue = allCode?.filter((item) => item !== valFunc);

  // console.log(valFunc, "posdposd");

  useEffect(() => {
    if (valFunc?.length !== 0) {
      setAllCode(valFunc);
    }
  }, [selectedColors]);

  // console.log(selectedColors, "stc");
  //   const metaData = useSelector(
	// 	(state) => state.productsfilters.meta
	// );

  // console.log(metaData ,"cechekkmetaa")

  const [imagePreviews, setImagePreviews] = useState([]);
  console.log(imagePreviews, "all");

  const [allErrors, setAllErrors] = useState({
    name: "",
    category_id: selectedProductCategory,
    sub_category_id: selectedProductSubCategory,
    unit_price: "",
    discount: "0",
    discount_type: "amount",
    current_stock: "",
    details: "",
    purchase_price: "",
  });

  const [fieldsData, setFieldsData] = useState({
    name: "",
    unit_price: "",
    current_stock: "",
    details: "",
    purchase_price: "",
  });

  const [selectedAttributes, setSelectedAttributes] = useState([]);
  const [mySelectedColors , setMySelectedColors] = useState([]);
  const [selectedAttributeValues, setSelectedAttributeValues] = useState([]);
  const [moqValues,setMoqValues] = useState([]);
  const onChangeMoqRowHandler = (e,slug,getRowIndex) => {
    const {name , value} = e.target;
    setMoqValues((preVal)=>{
      let newData = [...preVal?.map((val,index)=>{
        if(val?.slug === slug){
          return {
            ...val,
            rows : [
              ...val?.rows?.map((row,rowIndex)=>{
                if(rowIndex === getRowIndex){
                  return {...row , [name] : value}
                }else { 
                  return row;
                }
              })
            ]
          }
        }else{
          return val
        }
      })];
      // setParentMeta((preVal)=>[...newData]);
      return newData
    });
    // console.log("meta",meta)
    // if(meta?.length > 0){
    //   // localStorage.setItem("meta", JSON.stringify(meta) );
    //   // dispatch(ProductsFilterActions.setMeta(meta));
    // }
  }

  const onChangeMoqHandler = (e,slug) => {
    const {name , value} = e.target;
    setMoqValues((preVal)=>{
      let newData = [...preVal?.map((val,index)=>{
        if(val?.slug === slug){
          return {
            ...val,
            [name] : value
          }
        }else{
          return val
        }
      })];
      return newData
    });
    // if(meta?.length > 0){
    //   // localStorage.setItem("meta", JSON.stringify(meta) );
    //   // dispatch(ProductsFilterActions.setMeta(meta));
    // }
  }
  const onAddRowMoqHandler = (e,slug) => {
    setMoqValues((preVal)=>{
      let newData = [...preVal?.map((val,index)=>{
        if(val?.slug === slug){
          let newRows = [...val?.rows];
          (newRows?.length < 4) && newRows.push({
            maxQty : 0,
            minQty : 1,
            price : 0
          });
          return {
            ...val,
            rows : [...newRows]
          }
        }else{
          return val
        }
      })];
      return newData
    });
  }
  console.log(moqValues,"selectedAttributes",selectedAttributes,selectedAttributeValues,mySelectedColors);
  
  useEffect(()=>{
    setMoqValues((preval)=>{
      return ReUse.generateVariants(selectedAttributeValues)?.map((val)=>{
        if(val !== ""){
          return {
            slug : val?.toLowerCase(),
            qty : 1,
            sku : '',
            rows : [{
              maxQty : 0,
              minQty : 1,
              price : 0
            }]
          }
        }
      })
    });
  },[selectedAttributeValues]);

  

  // console.log(, "newGenerateVariants");

  const [uploadedImages, setUploadedImages] = useState([]);
  const [images, setImages] = useState([]);
  const [imagessent, setImagessent] = useState([]);


  const [inventoryTypes, setInventoryTypes] = useState([
    {
      value: 1,
      label: "Normal",
    },
    {
      value: 2,
      label: "Bulk",
    },
  ]);

  const [selectedInventoryType, setSelectedInventoryType] = useState(
    inventoryTypes[0]
  );

  const [sizeChart, setSizeChart] = useState();

  const { value, label } = selectedInventoryType ?? {};

  useEffect(() => {
    const sellerGetAttributes = AppService.sellerGetAttributes();
    ReUse.getApiData(sellerGetAttributes, setAttributes, setAttributesLoader);

    const sellerGetcategories = AppService.sellerGetcategories();
    ReUse.getApiData(
      sellerGetcategories,
      setProductCategories,
      setCategoriesLoader
    );
  }, []);

  useEffect(() => {
    const sellerGetsubCategories = AppService.sellerGetsubCategories({
      categoryId: selectedProductCategory?.value,
    });
    ReUse.getApiData(
      sellerGetsubCategories,
      setProductSubCategories,
      setSubCategoriesLoader
    );
  }, [selectedProductCategory]);

  useEffect(() => {
    const colorsall = AppService.sellercolorcategory();
    ReUse.getApiData(colorsall, setColors, setCategoriesLoader);
  }, []);

  // console.log(colors, "my all-colors");

  const extractAttributeOptions = ReUse.minifyArrayOfObjects({
    data: attributes,
  });

  const handleAttributeOptionAddition = ({
    attributeOption,
    attributeIndex,
    attributeType,
  }) => {
    const updatedAttributeOptions = [...attributeOptions];
    const { label, id } = attributeOption ?? {};
    console.log(
      "attributeoption",
      attributeOption,
      attributeType,
      attributeIndex
    );

    if (updatedAttributeOptions[attributeIndex]) {
      updatedAttributeOptions[attributeIndex].push({
        id: id,
        text: id,
      });
    } else {
      updatedAttributeOptions[attributeIndex] = [
        {
          id: id,
          text: id,
        },
      ];
    }

    setAttributeOptions(updatedAttributeOptions);

    // console.log(attributeOptions, "my-handle-function");

    // console.log(attributeOptions, "gty");

    const updatedSelectedAttributeValues = [...selectedAttributeValues];
    // console.log(updatedSelectedAttributeValues, "selectedattri");
    if (updatedSelectedAttributeValues[attributeIndex]) {
      updatedSelectedAttributeValues[attributeIndex]?.values?.push(
        attributeOption
      );
    } else {
      updatedSelectedAttributeValues[attributeIndex] = {
        selectedAttribute: attributeType,
        values: [attributeOption],
      };
    }
    // console.log(updatedSelectedAttributeValues, "meraa attribute option");

    setSelectedAttributeValues(updatedSelectedAttributeValues);
    // console.log(updatedSelectedAttributeValues ,"my updated version")
    // console.log(updatedSelectedAttributeValues,"yttttttrrrrr")
  };
  // ==========================================================================================

  // const handlecolorsOptionAddition = ({attributeOption,attributeIndex,attributeType }) =>{
  //   const updatedAttributeOptions = [...selectedColors];
  //   console.log(updatedAttributeOptions,"detrtetddddddd")

  //   const { label, id } = attributeOption ?? {};
  //   if (updatedAttributeOptions[attributeIndex])

  //   {
  //     updatedAttributeOptions[attributeIndex].push({
  //       id: id,
  //       text: id,
  //     });
  //   } else {
  //     updatedAttributeOptions[attributeIndex] = [
  //       {
  //         id: id,
  //         text: id,
  //       },
  //     ];
  //   }

  //   setAttributeOptions(updatedAttributeOptions);

  //   const updatedSelectedAttributeValues = [...selectedAttributeValues];
  //   console.log(updatedSelectedAttributeValues,"redhouse")

  //   if (updatedSelectedAttributeValues[attributeIndex]) {
  //     updatedSelectedAttributeValues[attributeIndex]?.values?.push(
  //       attributeOption
  //     );
  //   } else {
  //     updatedSelectedAttributeValues[attributeIndex] = {
  //       selectedAttribute: attributeType,
  //       values: [attributeOption],
  //     };
  //   }

  // }

  const handleAttributeOptionDelete = ({
    attributeOption,
    attributeIndex,
    attributeType,
  }) => {
    const updatedAttributeOptions = [...attributeOptions];

    if (updatedAttributeOptions[attributeIndex]) {
      const updatedValues = updatedAttributeOptions[attributeIndex]?.filter(
        (option) => option?.id !== attributeOption?.id
      );

      updatedAttributeOptions[attributeIndex] = updatedValues;

      setAttributeOptions(updatedAttributeOptions);
    }

    // console.log(attributeIndex, "rrrreeeeeeeefffffff");
  };

  const handleAttributeOptionDrag = (attributeOption, currPos, newPos) => {
    const newAttributeOptions = attributeOptions?.slice();
    newAttributeOptions?.splice(currPos, 1);
    newAttributeOptions?.splice(newPos, 0, attributeOption);
    setAttributeOptions(newAttributeOptions);
  };

  // const handleAttributeOptionDelete = ({
  // 	attributeOption,
  // 	attributeIndex,
  // 	attributeType,
  // }) => {
  // 	const updatedAttributeOptions = [...attributeOptions];
  // 	const currentAttributeOptions = updatedAttributeOptions[attributeIndex];

  // 	if (currentAttributeOptions) {
  // 		const updatedValues = currentAttributeOptions?.filter(
  // 			(option) => option?.id !== attributeOption?.id,
  // 		);

  // 		updatedAttributeOptions[attributeIndex] = updatedValues;

  // 		setAttributeOptions(updatedAttributeOptions);
  // 	}
  // };

  // const selectedcolor =(Varaitions) =>{
  //   if(selectedColors){
  //     selectedColors?.values?.push(
  //       Varaitions
  //     )

  //   }
  // };

  // console.log(selectedColors, "meraa dost");

  const handleAttributeOptionClick = (index) => {};

  function handleChange(e) {
    e.preventDefault();
    const resetErrors = ReUse.resetErrors({ fields: allErrors });
    setAllErrors(resetErrors);
    const { value, name } = e.target;

    // console.log("this", name, value, fieldsData);
    setFieldsData({
      ...fieldsData,
      [name]: value,
    });
  }

  const onSubmitHandler = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);

      const { name, unit_price, current_stock, details, purchase_price } =
        fieldsData ?? {};

      const fields = {
        name,
        unit_price,
        current_stock,
        details,
        purchase_price,
        category_id: selectedProductCategory,
        sub_category_id: selectedProductSubCategory,
        discount: "0",
        discount_type: "amount",
        thumbnail: fileupload,
        sizeChart: sizeChart,
      };
      const allErrors = ReUse.validateRequired({ fields: fields });

      // Check if there are any errors
      if (Object.keys(allErrors).length > 0) {
        setAllErrors(allErrors);
        setLoading(false);
        return;

        // console.log(allErrors, "all-my-errors");
      }

      if (imagessent?.length < 3) {
        setLoading(false);
        dispatch(errorMessage("Please  Upload Atleast 3 images"));
        dispatch(clearResponseMessageAfterDelay());
        return;
      }

      if (selectedInventoryType?.value === 1) {
        if (variantData?.length < 1) {
          setLoading(false);
          dispatch(errorMessage("Please Add atleast 1 variant"));
          dispatch(clearResponseMessageAfterDelay());
          return;
        }
      }

      if (selectedInventoryType?.value === 2) {
        if (bulkVariantData?.length < 1) {
          setLoading(false);
          dispatch(errorMessage("Please Add atleast 1 variant"));
          dispatch(clearResponseMessageAfterDelay());
          return;
        }
      }

      const moqData = meta?.map((data, index) => {
        // const fieldsData = bulkVariantAddFieldsData[index] || [];
        const moqs =
        data?.rows?.map(({ minimoq, maximoq, price, variantTitle, index }) =>
         ({
              // moq,
              minimoq,
              maximoq,
              price,
              variantTitle,
            })
          ) || [];

        return {
          qty: data?.qty,
          sku: data?.sku,
          type: data?.type,
          moqs: moqs,
        };
      });

      // const variation = variation;

      const payload = {
        name: name,
        category_id: selectedProductCategory,
        sub_category_id: selectedProductSubCategory,
        choice_attributes: choiceAttributes,
        // "choice_options_5": storval,
        choice: choice,
        choice_no: choiceNo,
        colors: allCode,
        unit_price: parseInt(unit_price),
        current_stock: parseInt(current_stock),
        discount: 0,
        discount_type: "amount",
        details: details,
        purchase_price: parseInt(purchase_price),
        images: imagessent?.map((item) => item?.file),
        thumbnail: file,
        tax: 0,
        sizechart: sizeChart,

        // variation:{variation},
        // [Object.keys(variation)] : "10",
      };

      // console.log([Object.keys(variation)]  ,"vvvvvvvvvvvvvvvvv")

      // var data = new FormData();
      // data.append("name", name);
      // // data.append("category_id", selectedProductCategory);
      // selectedProductCategory?.map((category_id) => {
      //   data.append("category_ids[]", category_id);
      // });
      // data.append("sub_category_id", selectedProductSubCategory);
      // data.append("choice_attributes", choiceAttributes);
      // data.append("choice", choice);
      // data.append("choice_no",choiceNo);
      // data.append("unit_price" ,parseInt(unit_price));
      // data.append("current_stock" ,parseInt(current_stock));
      // data.append("discount" ,0);
      // data.append("discount_type" ,"amount");
      // data.append("details" ,details);
      // data.append("purchase_price",parseInt(purchase_price));
      // data.append("images" ,images);
      // data.append("thumbnail", fileupload);
      // data.append("tax" ,0);
      // data.append("sizechart" ,sizeChart);

      // let varycheck = variation.length;

      // let value = 12

      // console.log(`{price_${[variation?.variation1]} : ${value}}` ,"ftfrrere")

      // console.log(variation.length, "check my variation");

      choiceOptions?.forEach((option) => {
        Object.entries(option).forEach(([key, value]) => {
          payload[key] = value;
        });
      });
      // console.log(choiceOptions, "check the color");
      if (selectedInventoryType?.value === 1) {
        // payload.variations = variantData;
        variantData.map((val, index) => 
        
        {
          Object.assign(payload, { [`price_${val?.sku}`]: val?.price });
          Object.assign(payload, { [`sku_${val?.sku}`]: val?.sku });
          Object.assign(payload, { [`qty_${val?.sku}`]: val?.qty });
        });
        payload.moq_selling = [];
        payload.colors_active = 1;
      }
      // console.log(variantData, "huhuhhttttrtcxcx");
      if (selectedInventoryType?.value === 2) {
        payload.moq_selling = moqData;
        payload.colors_active = 1;
      }

      // let varaiantkey = generatedVariations;
      // console.log(varaiantkey, "huuhhuhurrerrrrrrrrrrrr");
      // console.log(payload, "hyttypayload");

      const apiResp = await AppService.sellerAddProduct(payload);
      const { message, response } = apiResp.data;
      setLoading(false);
      dispatch(successMessage(message));
      setTimeout(() => {
        dispatch(successMessage("Navigating..."));
        setTimeout(() => {
          dispatch(successMessage(""));
          navigate("/seller-product-inventory");
        }, 1000);
      }, 1000);

      ReUse.resetErrors({ fields: allErrors }); // allErrors is an object
      ReUse.resetForm({ fields: fieldsData }); // fieldsData is an object
    } catch (err) {
      setLoading(false);
      dispatch(errorMessage(err?.response?.data?.message));
      dispatch(clearResponseMessageAfterDelay());
      ReUse.resetErrors({ fields: allErrors }); // allErrors is an object
      ReUse.resetForm({ fields: fieldsData }); // fieldsData is an object
      dispatch(successMessage(""));
    }
  };

  // const handleThumbnailUpload = (e) => {
  //   const resetErrors = ReUse.resetErrors({ fields: allErrors });
  //   setAllErrors(resetErrors);
  //   ReUse.handleFileUploads(e).then((result) => {
  //     const { fileOutput, fileUpload } = result;
  //     console.log(fileOutput, fileUpload,"lsdkakj")
  //     setFile(fileOutput);
  //     setFileupload(fileUpload);
  //   });
  // };

  const handleImageUpload = (e) => {
    e.preventDefault();
    const reader = new FileReader();
    const file = e.target.files[0];
    console.log(file, "doenfile");
    reader.onloadend = () => {
      setFile(file);
      setFileupload(reader.result);
      //   setFileupload(file);
      //   console.log(file, "newFile")
    };
    reader.readAsDataURL(file);
    // setUploadLoading(true);
  };

  const handleMultipleImagesUpload = async (e) => {
    const resetErrors = ReUse.resetErrors({ fields: allErrors });
    setAllErrors(resetErrors);
    try {
      const newImages = await ReUse.handleMultipleImagesUpload({
        e: e,
        prevImages: uploadedImages,
      });

      setUploadedImages(newImages);
    } catch (error) {}
  };

  // const handleImageChange = (e) => {
  //   const files = Array.from(e.target.files);

  //   // Map through the selected files and create URL for each
  //   const imageUrls = files.map((file) => URL.createObjectURL(file));

  //   // Update state with selected images and their URLs
  //   setImages((prevImages) => [...prevImages, ...imageUrls]);
  // };

  const SellerAddProductHook = SellerAddProduct(extractAttributeValues());
  const { generatedVariations, useVariantDataHandler } = SellerAddProductHook;

  const [
    variantData,
    variantDataHandler,
    bulkVariantData,
    bulkVariantDataHandler,
    bulkVariantMOQs,
    variantMOQsHandler,
    bulkVariantAddFieldsData,
    metaData,
    setMetaData,
    onChangeMetaRowHandler,
    onChangeMetaHandler,
    onAddRowMetaHandler
  ] = useVariantDataHandler();

  // console.log(variantData ,"myvariatnt")

  // const handleImageChange = (e) => {
  //   const files = e.target.files;
  //   const imagePreviewsArray = [];

  //   for (let i = 0; i < files.length; i++) {
  //     const reader = new FileReader();
  //     const file = files[i];

  //     reader.onload = (event) => {
  //       // Push base64 string to the imagePreviewsArray
  //       imagePreviewsArray.push({ file, preview: event.target.result });
  //       if (imagePreviewsArray.length === files.length) {
  //         // When all files are processed, update the state with image previews
  //         setImagePreviews([...imagePreviews, ...imagePreviewsArray]);
  //       }
  //     };

  //     reader.readAsDataURL(file);
  //   }
  // };

  // const handleImageUpload = e => {
  //   const tempArr = [];

  //   [...e.target.files].forEach(file => {
  //     console.log("file >>> ", file);

  //     tempArr.push({
  //       data: file,
  //       url: URL.createObjectURL(file)
  //     });

  //     console.log("pictures >> ", pictures);
  //   });

  //   setPictures(tempArr);
  // };

  // const handleImageUpload = (e) => {
  // 	e.preventDefault();
  // 	if (e.target.files) {
  // 		const filesArray = Array.from(e.target.files).map((file) =>
  // 			URL.createObjectURL(file),
  // 		);
  // 		setMultiImageFiles((prevImages) => prevImages.concat(filesArray));
  // 		Array.from(e.target.files).map(
  // 			(file) => URL.revokeObjectURL(file), // avoid memory leak
  // 		);
  // 		Array.from(e.target.files).map((file) => {
  // 			setUploadImages((preVal) => {
  // 				return [...preVal, file];
  // 			});
  // 		});
  // 	}
  // };

  const handleFileUpload = (event) => {
    const files = event.target.files;
    for (let i = 0; i < files.length; i++) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setImagessent((prevImages) => [
          ...prevImages,
          {
            file: files[i],
            previewUrl: e.target.result,
          },
        ]);
      };
      reader.readAsDataURL(files[i]);
    }
  };
  const extractColorsAttributeValues = () => {
    try {
      if (!selectedColors || !Array.isArray(selectedColors)) {
        return [];
      }

      // const attributeValues = selectedColors.map(
      //   ({ selectedAttribute, values }) => {
      //     if (!selectedAttribute || !values || !Array.isArray(values)) {
      //       return [];
      //     }

      //     const labels = values?.map(({ text }) => text);
      //     return { [selectedAttribute]: labels };
      //   }
      // );

      // value
      // label
      const attributeValues = selectedColors.map((item, index) => {
        if (!selectedColors || !selectedColors) {
          return [];
        }
        const labels = item?.value;
        return {
          [`${item?.label}-${attributeOptions?.[0]?.[0]?.text}`]: labels,
        };
      });

      const mergedAttributes = Object.assign({}, ...attributeValues);
      return attributeValues;
    } catch (error) {
      return [];
    }
  };

  const extractCategoriesOptions = ReUse.minifyArrayOfObjects({
    data: productCategories,
  });

  const extractSubCategoriesOptions = ReUse.minifyArrayOfObjects({
    data: productSubCategories,
  });

  // const SellerAddProductColorHook = SellerAddProduct(
  //   extractColorsAttributeValues()
  // );
  const [background, setBackground] = useState("");
  const [hexa, setHexa] = useState(background);
  const [parentMeta , setParentMeta] = useState([]);
  console.log("meta 1",parentMeta);

  // console.log(SellerAddProductColorHook,"sdsdsde323443")
  // const { generatedVariations: ggggg } = SellerAddProductColorHook;

  // console.log(bulkVariantData, "hyhyyfy");

  const handleSelect = (option, currentIndex) => {
    handleAttributeOptionAddition({
      // attributeOption: { id : ((option.length> 0)? option[0]?.label : '') , text : ((option.length> 0)? option[0]?.label : '') } ,
      attributeOption: option,
      attributeIndex: currentIndex || 0,
      attributeType: label || "",
    });
  };

  const IndividualVariantProps = {
    variantData,
    variantDataHandler,
    extractAttributeOptions,
    setSelectedAttributes,
    selectedAttributes,
    attributeOptions,
    delimiters,
    handleAttributeOptionDelete,
    handleAttributeOptionAddition,
    handleAttributeOptionDrag,
    generatedVariations,
    handleAttributeOptionClick,
    colorssdsd,
    setAllCode,
    // ggggg,
  };

  const BulkVariantProps = {
    bulkVariantData,
    bulkVariantDataHandler,
    bulkVariantMOQs,
    variantMOQsHandler,
    extractAttributeOptions,
    setSelectedAttributes,
    selectedAttributes,
    attributeOptions,
    delimiters,
    handleAttributeOptionDelete,
    handleAttributeOptionAddition,
    handleAttributeOptionDrag,
    handleAttributeOptionClick,
    generatedVariations,
    bulkVariantAddFieldsData,
    colorssdsd,
    setAllCode,
    setMinimoq,
    setMaximoq,
    setPrice,
    minimoq,
    maximoq,
    price,
    ///
    metaData,
    setMetaData,

    ///
    setParentMeta,
    //
    setMySelectedColors,
    selectedAttributeValues,
    moqValues,
    onChangeMoqRowHandler,
    onChangeMoqHandler,
    onAddRowMoqHandler,
  };

  const SelectedInventoryType = () => {
    if (value === 1) {
      return (
        <>
          <IndividualVariant inventoryVariantProps={IndividualVariantProps} />
        </>
      );
    } else if (value === 2) {
      return (
        <>
          <BulkVariant inventoryVariantProps={BulkVariantProps} />
        </>
      );
    } else {
      return null;
    }
  };

  // const UploadedImages = () => {
  //   if (uploadedImages?.length > 0) {
  //     console.log(uploadedImages, "uhuhuhuhu");
  //     return (
  //       <>
  //         <div className="uploaded-images-wrapper">
  //           {uploadedImages?.map((image) => (
  //             <RenderUploadedImage imageURL={image} />
  //           ))}
  //         </div>
  //       </>
  //     );
  //   } else {
  //     return null;
  //
  // };

  useEffect(() => {
    if (selectedAttributes) {
      // const ids = selectedAttributes?.map(({ value }) => value);
      // const idcheck = selectedAttributes?.filter((value) => value?.value === parseInt("5"));
      // const ids =[5];
      // const ids = selectedAttributes?.filter((value) => {
      //   if(value?.value === parseInt("5")){
      //     return
      //     selectedAttributes.push(value);
      //   }
      // })

      // const checkid = selectedAttributes?.filter(value => value.includes(parseInt("5"))).map(({value}) => value);
      const ids = selectedAttributes
        ?.filter((value) => value?.value === parseInt("5"))
        .map(({ value }) => value);
      // const ids = selectedAttributes?.map(({ value }) => value);

      // const ids = [5] ;
      // console.log(checkid, "doenthieking");
      const labels = selectedAttributes
        ?.filter((label) => label?.label === "Size")
        .map(({ label }) => label);

      // const labels = selectedAttributes?.map(({ label }) => label);

      console.log(labels, "derto");
      // console.log(labels, "doen with labels");

      setchoiceAttributes(ids);
      setChoiceNo(ids);
      setChoice(labels);
    }
  }, [selectedAttributes]);

  // console.log(selectedAttributes, "bhae krlo select");

  // console.log(
  //   selectedAttributeValues?.filter(
  //     (selected) => selected?.selectedAttribute === "Size"
  //   ),
  //   "myselectedattributesvalue"
  // );

  // useEffect(() => {
  //   if (selectedAttributeValues) {
  //     let myData = []
  //     let some =
  //       selectedAttributeValues
  //         ?.filter((selected) => selected?.selectedAttribute === "Size")
  //         ?.values?.map(({ text }) => myData.push(text)) || [];

  //         console.log(myData ,"mysaveindata")
  //   }
  // },[selectedAttributeValues]);
  // useEffect(() => {
  //   if (selectedAttributeValues) {
  //     let someData = [];

  //     someData.unshift();

  //     const myvalues =
  //       selectedAttributeValues
  //         ?.filter((selected) => selected?.selectedAttribute === "Size")
  //         ?.[0]?.values?.map(({ text }) => someData.push(text.trim())) || [];

  //     setStoreVal(someData);
  //     console.log(someData ,"somemy")
  //   }
  // }, [selectedAttributeValues]);

  useEffect(() => {
    if (selectedAttributeValues) {
      let someData = [];
      const choiceOptions = choiceAttributes?.map((choiceAttribute, index) => ({
        [`choice_options_${choiceAttribute}`]: [
          (
            selectedAttributeValues
              ?.filter((selected) => selected?.selectedAttribute === "Size")
              ?.[index]?.values?.map(({ text }) => text) || []
          )?.join(),
        ],
      }));
      // console.log( selectedAttributeValues
      //   ?.filter((selected) => selected?.selectedAttribute === "Size")
      //   ?.values,"deeeeeertttttttttt")

      setChoiceOptions(choiceOptions);
    }
  }, [selectedAttributeValues]);

  const handleSizeChartUpload = (e) => {
    const resetErrors = ReUse.resetErrors({ fields: allErrors });
    setAllErrors(resetErrors);
    ReUse.handleFileUploads(e).then((result) => {
      const { fileOutput, fileUpload } = result;
      setSizeChart(fileOutput);
      setSizeChart(fileUpload);
    });
  };

  // console.log(<TwitterPicker /> ,"my-twitter-picker")

  // const saveColors = (color) => {
  //   setBackground(color.hex);
  //   setHexa(color.hex);
  // };
  const saveColors2 = (e) => {
    setHexa(e.target.value);
    setBackground(e.target.value);
  };
  const toggleChecked = () => setPicker((value) => !value);

  function deleteFile(e) {
    const s = imagessent.filter((item, index) => index !== e);
    setImagessent(s);
  }

  return (
    <>
      <AccessControl allowedRoles={["seller"]}>
        <SellerHeader />
        {/* Seller Adding Product starts here */}
        <section className="seller-dashboard">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-3 ps-0">
                <SellerSidebar />
              </div>
              <div className="col-lg-8">
                <div className="edit-profile-card edit-no-padding-right adding-main-product-scroll">
                  <div className="edit-heading-wrapper">
                    <h2>Adding product</h2>
                  </div>

                  <div className="seller-edit-with-border-dv">
                    <div className="row">
                      <div className="col-md-10">
                        <div className="edit-">
                          <div className="seller-all-form">
                            <form>
                              <div className="row">
                                <div className="col-md-6">
                                  <div className="seller-edit-form-dropdown">
                                    <Select
                                      isMulti={false}
                                      name="categories"
                                      options={extractCategoriesOptions}
                                      // className="form-select"
                                      classNamePrefix="select"
                                      onChange={(option) => {
                                        setSelectedProductCategory(
                                          option?.value
                                        );
                                        const resetErrors = ReUse.resetErrors({
                                          fields: allErrors,
                                        });
                                        setAllErrors(resetErrors);
                                      }}
                                    />
                                    <FieldError
                                      fieldName={allErrors?.category_id}
                                    />
                                  </div>
                                </div>

                                <div className="col-md-6">
                                  <div className="seller-edit-form-dropdown">
                                    <Select
                                      isMulti={false}
                                      name="categories"
                                      options={extractSubCategoriesOptions}
                                      // class="form-select"
                                      classNamePrefix="select"
                                      onChange={(option) => {
                                        setSelectedProductSubCategory(
                                          option?.value
                                        );
                                        const resetErrors = ReUse.resetErrors({
                                          fields: allErrors,
                                        });
                                        setAllErrors(resetErrors);
                                      }}
                                    />
                                    <FieldError
                                      fieldName={allErrors?.sub_category_id}
                                    />
                                  </div>
                                </div>

                                <div className="col-md-6">
                                  <div className="seller-edit-form-input">
                                    <input
                                      type="text"
                                      placeholder="Product Name"
                                      onChange={handleChange}
                                      name="name"
                                      value={fieldsData?.name}
                                    />
                                    <FieldError fieldName={allErrors?.name} />
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="seller-edit-form-input">
                                    <input
                                      type="text"
                                      placeholder="Stock Quantity"
                                      onChange={handleChange}
                                      name="current_stock"
                                      value={fieldsData?.current_stock}
                                    />
                                    <FieldError
                                      fieldName={allErrors?.current_stock}
                                    />
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="seller-edit-form-input">
                                    <input
                                      type="text"
                                      placeholder="Unit Price"
                                      onChange={handleChange}
                                      name="unit_price"
                                      value={fieldsData?.unit_price}
                                    />
                                    <FieldError
                                      fieldName={allErrors?.unit_price}
                                    />
                                  </div>
                                </div>

                                <div className="col-md-6">
                                  <div className="seller-edit-form-input">
                                    <input
                                      type="text"
                                      placeholder="Purchase Price"
                                      onChange={handleChange}
                                      name="purchase_price"
                                      value={fieldsData?.purchase_price}
                                    />
                                    <FieldError
                                      fieldName={allErrors?.purchase_price}
                                    />
                                  </div>
                                </div>

                                <div className="col-md-12">
                                  <div className="seller-edit-form-input">
                                    <textarea
                                      class="form-control"
                                      id="exampleFormControlTextarea1"
                                      rows="3"
                                      placeholder="Description"
                                      name="details"
                                      value={fieldsData?.details}
                                      onChange={handleChange}
                                    ></textarea>
                                    <FieldError
                                      fieldName={allErrors?.details}
                                    />
                                  </div>
                                </div>
                              </div>
                            </form>

                            {/* <TwitterPicker /> */}
                            <div className="col-md-12">
                              {/* <div className="label-and-upload-product-btn">
                                <label>Select Product Images</label>
                              </div> */}
                              <div className="mcq-dv-all">
                                <h5>Select Product Images / Chart Images</h5>
                              </div>
                            </div>
                            <div className="row">
                              <div className="label-and-upload-product-btn">
                                <div className="col-md-4">
                                  <div className="button-render-img-dv">
                                    <div className="upload-btn">
                                      <button>
                                        <span>
                                          <img
                                            className="img-fluid"
                                            alt="upper-arrow"
                                            src={upperarrow}
                                          />{" "}
                                          Upload Pictures
                                        </span>
                                        <input
                                          type="file"
                                          accept="image/*"
                                          multiple={true}
                                          // onChange={handleMultipleImagesUpload}
                                          // onChange={handleImageChange}
                                          onChange={handleFileUpload}
                                        />
                                      </button>
                                    </div>

                                    {/* style={{
                                                      width: "60px",
                                                      height: "60px",
                                                      objectFit: "cover",
                                                    }} */}

                                    <div className="label-and-upload-box-shadow">
                                      <figure>
                                        {/* <img className="img-fluid" src={sketch} /> */}
                                        {imagessent.length > 0 ? (
                                          <>
                                            {imagessent.map((image, index) => (
                                              <div
                                                className="preview-img"
                                                key={index}
                                              >
                                                <img
                                                  src={image.previewUrl}
                                                  alt={`Preview ${index}`}
                                                  className="image-pre img-fluid"
                                                  style={{
                                                    width: "60px",
                                                    height: "60px",
                                                    objectFit: "cover",
                                                  }}
                                                />
                                                {/* <p>{image.file.name}</p> */}
                                                <div className="img-cancel-btn">
                                                  <i
                                                    onClick={() =>
                                                      deleteFile(index)
                                                    }
                                                    class="fa fa-times"
                                                    aria-hidden="true"
                                                  ></i>
                                                </div>
                                              
                                              </div>
                                            ))}
                                          </>
                                        ) : (
                                          <>
                                            {" "}
                                            <div className="all-img-with-shadow shadow-width">
                                              <img
                                                className="img-fluid"
                                                src={sketch}
                                              />
                                            </div>
                                          </>
                                        )}
                                      </figure>
                                    </div>
                                  </div>
                                </div>

                                <div className="col-md-4">
                                  <div className="button-render-img-dv">
                                    <div className="upload-btn">
                                      <button>
                                        <span>
                                          <img
                                            className="img-fluid"
                                            alt="upper-arrow"
                                            src={upperarrow}
                                          />{" "}
                                          Upload Thumbnail
                                        </span>
                                        <input
                                          type="file"
                                          accept="*"
                                          multiple={false}
                                          // onChange={handleThumbnailUpload}
                                          onChange={handleImageUpload}
                                        />
                                        {/* <input
                                          name="images"
                                          type="file"
                                          accept="*"
                                          onChange={handleImageUpload}
                                          multiple={false}
                                          className="d-none"
                                        /> */}
                                      </button>
                                      <FieldError
                                        fieldName={allErrors?.thumbnail}
                                      />
                                    </div>

                                    <div className="label-and-upload-box-shadow">
                                      <div className="all-img-with-shadow">
                                        <figure>
                                          {/* <img className="img-fluid" src={sketch} /> */}
                                          <RenderImage file={fileupload} />
                                        </figure>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="col-md-4">
                                  <div className="button-render-img-dv">
                                    <div className="upload-btn">
                                      <button>
                                        <span>
                                          <img
                                            className="img-fluid"
                                            alt="upper-arrow"
                                            src={upperarrow}
                                          />{" "}
                                          Upload Size Chart
                                        </span>
                                        <input
                                          type="file"
                                          accept="image/*"
                                          multiple={false}
                                          onChange={handleSizeChartUpload}
                                        />
                                      </button>
                                      <FieldError
                                        fieldName={allErrors?.sizeChart}
                                      />
                                    </div>
                                    <div className="label-and-upload-box-shadow">
                                      <div className="all-img-with-shadow">
                                        <figure>
                                          {/* <img className="img-fluid" src={sketch} /> */}
                                          <RenderImage file={sizeChart} />
                                        </figure>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="col-md-4"></div>
                                <div className="col-md-4"></div>
                                <div className="col-md-4"></div>
                              </div>
                              {/* <div className="label-and-upload-box-shadow">
                                  {/* <UploadedImages /> */}
                              {/* {imagePreviews.map((image, index) => (
                                    <div key={index}>
                                      <img
                                        src={image.preview}
                                        alt={`Preview ${index}`}
                                        style={{
                                          width: "100px",
                                          height: "100px",
                                          objectFit: "cover",
                                        }}
                                      />
                                      <p>{image.file.name}</p>
                                    </div>
                                  ))} */}

                              {/* <RenderImage file={fileupload} /> */}
                              {/* <RenderImage file={sizeChart} /> */}
                              {/* </div> */}
                              {/* 
                              <div className="label-and-upload-box-shadow">
                                <figure>
                                  <img className="img-fluid" src={sketch} />
                                  {imagePreviews.map((image, index) => (
                                    <div key={index}>
                                      <img
                                        src={image.preview}
                                        alt={`Preview ${index}`}
                                        style={{
                                          width: "60px",
                                          height: "60px",
                                          objectFit: "cover",
                                        }}
                                      />
                                      <p>{image.file.name}</p>
                                    </div>
                                  ))}
                                </figure>
                                <div className="all-img-with-shadow">
                                  <figure>
                                    <img className="img-fluid" src={sketch} />
                                  </figure>
                                </div>
                                <div className="all-img-with-shadow">
                                  <figure>
                                    <img className="img-fluid" src={sketch} />
                                  </figure>
                                </div>
                                <div className="all-img-with-shadow">
                                  <figure>
                                    <img className="img-fluid" src={sketch} />
                                    <RenderImage file={fileupload} />
                                  </figure>
                                </div>

                                <div className="all-img-with-shadow">
                                  <figure>
                                    <img className="img-fluid" src={sketch} />
                                    <RenderImage file={sizeChart} />
                                  </figure>
                                </div>
                                <div className="all-img-with-shadow">
                                  <figure>
                                    <img className="img-fluid" src={sketch} />
                                  </figure>
                                </div>
                              </div> */}

                              {/* <TwitterPicker
                                className={picker ? "picker-show" : ""}
                                onChangeComplete={saveColors}
                                color={hexa}
                              /> */}
                              <div className="mcq-dv-all">
                                <h5>Select Inventory Type</h5>
                              </div>
                              <Select
                                isMulti={false}
                                options={inventoryTypes}
                                class="form-select mt-2 mb-2"
                                classNamePrefix="select Inventory Type"
                                onChange={(type) => {
                                  setSelectedInventoryType(type);
                                  setSelectedAttributes([]);
                                }}
                                value={selectedInventoryType}
                              />
                              {/* <div className="col-md-12">
                                <div className="mcq-dv-all">
                                  <h5>Select Colors</h5>
                                </div>
                                <Select
                                  isMulti={true}
                                  options={colorssdsd}
                                  class="form-select mt-2 mb-2"
                                  classNamePrefix="select Inventory Type"
                                  value={selectedColors}
                                  onChange={(option, currentIndex) => {
                                    option = {id:option?.[0]?.label,text:option?.[0]?.label}
                                    setSelectedColors(
                                      handleAttributeOptionAddition({
                                        attributeOption: option || {},
                                        attributeIndex: 0 || 0,
                                        attributeType: label || "",
                                      })
                                    );
                                  }}
                                />

                                <selectedColors />
                              </div> */}
                              <SelectedInventoryType />
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* <div className="col-lg-6">
                        <div className="radio-box color-picker right-side">
                          <div className="head">
                            <h3>Hex Code</h3>
                          </div>
                          <div className="form-group">
                            <div className="clip-field">
                              <input
                                type="text"
                                value={hexa}
                                onChange={saveColors2}
                                placeholder="Enter Hex or select "
                                className="form-control"
                              />
                              <button
                                onClick={toggleChecked}
                                className="background"
                                style={{ backgroundColor: hexa }}
                              ></button>
                            </div>
                            <TwitterPicker
                              className={picker ? "picker-show" : ""}
                              onChangeComplete={saveColors2}
                              color={hexa}
                            />
                          </div>
                        </div>
                      </div> */}

                      <div className="col-md-2">
                        <div className="seller-save-btn">
                          <CustomButton
                            loading={loading}
                            onClickHandler={onSubmitHandler}
                            customClassName="custom-btn"
                          >
                            Create
                          </CustomButton>
                          <ResponseMessage />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Seller Adding Product ends here */}
      </AccessControl>
    </>
  );
}

export default Addingproduct;
